import { createStore } from 'vuex'
import { search } from './modules/search'
import user from './modules/user'
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    search,
    user,
  },
  plugins: [createPersistedState({
    key: 'tesri_website',
  })]
})

export default store
